<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-list">
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/3 xl:w-1/4 sm:w-full mb-2">
        <div
          class="vx-card p-5"
          style="overflow: auto"
          :style="isSmallerScreen ? '' : `height: 75vh`"
        >
          <vs-input
            class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
            v-model="keyword"
            @keyup="search"
            placeholder="Search..."
          />
          <div class="table-container">
            <vs-button @click="addPolygon" class="mr-2 mt-2 btn-custom"
              >Add Polygon</vs-button
            >
            <vs-button @click="addMarker" class="btn-custom" color="success"
              >Add Marker</vs-button
            >
            <h3 class="sidebar-title">POI List</h3>

            <vs-row vs-type="flex" vs-justify="flex-end">
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <div
                  class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                >
                  <span class="mr-2"
                    >{{ page * per_page - (per_page - 1) }} -
                    {{
                      row_total - page * per_page > 0
                        ? page * per_page
                        : row_total
                    }}
                    of {{ row_total }}</span
                  >
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="updatePerPage(10)">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="updatePerPage(25)">
                    <span>25</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="updatePerPage(50)">
                    <span>50</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="updatePerPage(100)">
                    <span>100</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="updatePerPage(250)">
                    <span>250</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="updatePerPage(500)">
                    <span>500</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="updatePerPage(1000)">
                    <span>1000</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-row>

            <table class="sidebar-table mt-2">
              <thead>
                <tr>
                  <th style="min-width: 15px">
                    <vs-checkbox
                      title="Check All"
                      icon-pack="feather"
                      icon="icon-map-pin"
                      color="rgb(38, 187, 174)"
                      v-model="selectedAll"
                      @click="checkAll($event)"
                    ></vs-checkbox>
                  </th>
                  <th>Name</th>
                  <th v-if="actor.privilege < 4">User</th>
                  <th>#</th>
                </tr>
              </thead>
              <tbody v-if="data.length > 0">
                <tr v-for="(item, index) in data" :key="index">
                  <td>
                    <vs-checkbox
                      icon-pack="feather"
                      icon="icon-map-pin"
                      color="rgb(38, 187, 174)"
                      v-model="selected"
                      :vs-value="item.id"
                      @click="check(item, $event)"
                    ></vs-checkbox>
                  </td>
                  <td>{{ item.name }}</td>
                  <td v-if="actor.privilege < 4">{{ item.username }}</td>
                  <td>
                    <vs-dropdown vs-trigger-click>
                      <vs-button
                        radius
                        color="dark"
                        type="flat"
                        icon-pack="feather"
                        icon="icon-settings"
                      ></vs-button>

                      <vs-dropdown-menu>
                        <vs-dropdown-item @click="edit(item.id)"
                          >Edit</vs-dropdown-item
                        >
                        <vs-dropdown-item @click="del(item.id)"
                          >Delete</vs-dropdown-item
                        >
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td
                    v-if="loading"
                    colspan="4"
                    class="text-center"
                    style="padding: 10px"
                  >
                    <vs-icon icon-pack="feather" icon="icon-loader"></vs-icon>
                    Loading....
                  </td>
                  <td
                    v-else
                    colspan="4"
                    class="text-center"
                    style="padding: 10px"
                  >
                    No Data Available
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <vs-pagination
            style="margin-top: 20px"
            color="rgb(38, 187, 174)"
            :total="n_page"
            v-model="page"
          ></vs-pagination>
        </div>
      </div>
      <div class="vx-col w-full lg:w-2/3 xl:w-3/4 sm:w-full">
        <div
          class="vx-card p-3"
          :style="isSmallerScreen ? `height: 82vh` : `height: 75vh`"
        >
          <l-map
            id="map"
            ref="map"
            :center.sync="map.center"
            :zoom="map.zoom"
            :options="mapOptions"
            style="min-height: 100px"
          >
            <l-control-polyline-measure
              :options="{ showUnitControl: false }"
              position="topleft"
            />
            <l-control-layers position="topright"></l-control-layers>
            <l-tile-layer
              v-for="tileProvider in tileProviders"
              :key="tileProvider.name"
              :name="tileProvider.name"
              :visible="tileProvider.visible"
              :url="tileProvider.url"
              :attribution="tileProvider.attribution"
              layer-type="base"
            />
            <l-polygon
              v-for="item in polygons"
              :key="item.id"
              :lat-lngs="item.latlngs"
              :visible="item.visible"
            ></l-polygon>
            <l-marker
              v-for="item in markers"
              :key="item.id"
              :lat-lng="item.latlngs"
              :visible="item.visible"
              :icon="item.icon"
            >
              <l-tooltip
                :options="{
                  permanent: true,
                  interactive: true,
                  direction: 'right'
                }"
                >{{ item.name }}</l-tooltip
              >
            </l-marker>
          </l-map>
        </div>
      </div>

      <vs-popup
        classContent="popup-example"
        :title="popupTitle"
        :active.sync="showPopup"
      >
        <template>
          <div class="vx-row mb-3" v-if="actor.privilege < 4">
            <div class="vx-col sm:w-2/2 w-full required">
              <label class="vs-input--label">User</label>
              <v-select
                @search="searchUser"
                :clearable="false"
                :options="userList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="w-full"
                v-model="input.user"
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 w-full required">
              <vs-input label="POI Name" class="w-full" v-model="input.name" />
            </div>
          </div>
          <div v-show="input.type === 0" class="vx-row mb-6">
            <div class="vx-col sm:w-2/2 w-full required">
              <label class="vs-input--label mb-2">Icon</label>
              <v-select :options="iconList" v-model="input.icon">
                <template slot="option" slot-scope="option">
                  <img
                    style="width: 50px; height: 50px"
                    :src="`${option.icon}`"
                  />
                </template>
              </v-select>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full ml-auto">
              <vs-button
                id="submitBtn"
                class="mr-3 mb-2 vs-con-loading__container"
                @click="submit"
                >Submit</vs-button
              >
            </div>
          </div>
        </template>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import L from 'leaflet'
import {
  LMap,
  LTileLayer,
  LMarker,
  LPolygon,
  LTooltip,
  LControlLayers
} from 'vue2-leaflet'
import LControlPolylineMeasure from 'vue2-leaflet-polyline-measure'
import vSelect from 'vue-select'
import 'leaflet-draw'

import 'leaflet/dist/leaflet.css'
import 'leaflet-draw/dist/leaflet.draw.css'

import { Icon } from 'leaflet'

delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  iconSize: [20, 30]
})

export default {
  components: {
    vSelect,
    LMap,
    LTileLayer,
    LMarker,
    LPolygon,
    LTooltip,
    LControlLayers,
    LControlPolylineMeasure
  },

  data() {
    return {
      data: [],
      actor: {},
      token: '',
      tileProviders: [
        {
          name: 'Google Street',
          visible: true,
          url: 'https://www.google.com/maps/vt?lyrs=m@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Satellites',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=s@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Hybrid',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=s,h@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Terrain',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=p@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'OpenStreetMap',
          visible: false,
          attribution:
            '&copy; <a target="_blank" href="https://osm.org/copyright">OpenStreetMap</a> contributors',
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
        }
      ],
      map: {
        center: L.latLng(-6.21011, 106.832459),
        zoom: 13
      },

      mapOptions: {
        minZoom: 2,
        zoomSnap: 0.5
      },

      userList: [],
      iconList: [],

      input: {
        name: '',
        user: '',
        lat: '',
        lon: '',
        type: '',
        geom: '',
        icon: ''
      },

      tempId: '',

      action: '',
      showPopup: false,
      popupTitle: '',

      selected: [],
      selectedAll: [],

      page: 1,
      per_page: 10,
      row_total: 0,
      keyword: '',
      timer: null,
      loading: true,

      polygons: [],
      markers: [],

      notify: 'Server Error'
    }
  },

  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 992
    },

    isWider() {
      return this.$store.state.windowWidth >= 1440
    },

    n_page() {
      return Math.ceil(this.row_total / this.per_page)
    },

    imgSource() {
      return `${this.$api.base_url}/uploads/icon`
    }
  },

  watch: {
    page() {
      this.initTable()
    },

    per_page() {
      if (this.page != 1) this.page = 1
      else this.initTable()
    },

    isWider() {
      this.initTable()
    }
  },

  created() {
    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''
    this.$http
      .get(`${this.$api.endpoint}/user/profile`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then((res) => {
        this.actor = res.data.message.data
        this.input.user = { value: this.actor.id, label: this.actor.username }
      })
      .catch((error) => {
        this.$gf.httpErrorHandler(error)
      })

    this.initTable()
    this.getPoiIcon()
  },

  mounted() {
    this.$nextTick(() => {
      const map = this.$refs.map.mapObject
      const editableLayers = new L.FeatureGroup().addTo(map)
      const drawControl = new L.Control.Draw({
        position: 'topright',
        draw: {
          polygon: {
            allowIntersection: false, // Restricts shapes to simple polygons
            drawError: {
              color: 'red', // Color the shape will turn when intersects
              message: "<strong>Oh snap!<strong> you can't draw that!" // Message that will show when intersect
            },
            shapeOptions: {
              color: 'green'
            }
          },
          // disable toolbar item by setting it to false
          polyline: false,
          rectangle: false,
          circle: false,
          marker: true,
          circlemarker: false
        }
      })
      map.addControl(drawControl)
      map.on(L.Draw.Event.CREATED, (e) => {
        const type = e.layerType
        const layer = e.layer

        this.input.name = ''
        if (this.actor.privilege < 4) this.input.user = ''
        // console.log(layer)
        if (type === 'marker') {
          this.input.type = 0
          this.input.lat = layer._latlng.lat
          this.input.lon = layer._latlng.lng
          this.input.geom = `POINT(${layer._latlng.lng} ${layer._latlng.lat})`
        } else {
          this.input.type = 1
          this.input.lat = layer._bounds._southWest.lat
          this.input.lon = layer._bounds._southWest.lng
          this.input.geom = this.polygonToGeom(layer._latlngs[0])

          // console.log(L.GeometryUtil.geodesicArea(layer.getLatLngs()))
        }

        // layer.addTo(map)
        this.action = 'add'
        this.popupTitle = 'Add POI'
        this.showPopup = true
      })
    })
  },

  methods: {
    updatePerPage(n) {
      this.per_page = n
    },

    addPolygon() {
      const map = this.$refs.map.mapObject
      const polygon = new L.Draw.Polygon(map)
      polygon.enable()
    },

    addMarker() {
      const map = this.$refs.map.mapObject
      const marker = new L.Draw.Marker(map)
      marker.enable()
    },

    search() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.page = 1
        this.initTable()
      }, 800)
    },

    searchUser(search) {
      if (search.length >= 3) {
        this.$http
          .get(`${this.$api.endpoint}/user/general?search=${search}`, {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          })
          .then((res) => {
            this.userList = res.data.message.data
          })
          .catch((error) => {
            this.$gf.httpErrorHandler(error)
          })
      } else {
        this.userList = []
      }
    },

    getPoiIcon() {
      this.$http
        .get(`${this.$api.endpoint}/poi_icon/select`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.iconList = res.data.message.data
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    onSelectImage(data) {
      this.input.icon = data.id
    },

    edit(id) {
      this.tempId = id
      this.action = 'edit'
      this.popupTitle = 'Edit POI'

      this.$http
        .get(`${this.$api.endpoint}/poi/detail/${id}`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          var data = res.data.message.data
          this.input.user = { value: data.user_id, label: data.username }
          ;(this.input.name = data.name), (this.input.lon = data.lon)
          this.input.lat = data.lat
          this.input.geom = data.geom
          this.input.type = data.type

          this.showPopup = true
          // this.userList = res.data.message.data
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    del(id) {
      this.tempId = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Delete POI`,
        text: 'Are you sure want to Delete this POI ?',
        accept: this.confirmDelete
      })
    },

    confirmDelete() {
      this.$http
        .post(
          `${this.$api.endpoint}/poi/delete/${this.tempId}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.notify = res.data.message.split('_').join(' ')
          this.initTable()

          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    submit() {
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: '#submitBtn',
        scale: 0.45
      })

      let url =
        this.action === 'add'
          ? `${this.$api.endpoint}/poi/add`
          : `${this.$api.endpoint}/poi/update/${this.tempId}`

      this.$http
        .post(
          url,
          {
            user_id: this.input.user ? this.input.user.value : '',
            name: this.input.name,
            type: this.input.type,
            lon: this.input.lon,
            lat: this.input.lat,
            geom: this.input.geom,
            icon_id: this.input.type === 0 ? this.input.icon.value : 0
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.$vs.loading.close('#submitBtn > .con-vs-loading')

          this.notify = res.data.message.split('_').join(' ')

          this.showPopup = false
          this.initTable()

          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.$vs.loading.close('#submitBtn > .con-vs-loading')
          this.$gf.httpErrorHandler(error)
        })
    },

    check(item, event) {
      let visible = event.target.checked
      let key = -1
      let target = item.type === 0 ? 'markers' : 'polygons'

      this[target].map((data, index) => {
        if (data.id === item.id) key = index
      })
      // console.log(key)
      if (key !== -1) {
        if (visible) {
          this.map.center = this[target][key].center
          // this.map.zoom = 10
        }
        this[target][key].visible = visible
      }

      // if(this.target.checked) {

      // } else {

      // }
    },

    checkAll(event) {
      let visible = event.target.checked

      if (!visible) this.selected = []

      this.markers.map((data, index) => {
        if (visible) this.selected.push(data.id)

        this.markers[index].visible = visible
      })

      this.polygons.map((data, index) => {
        if (visible) this.selected.push(data.id)

        this.polygons[index].visible = visible
      })
    },

    initTable() {
      // if(!this.isWider) this.per_page = 5
      // else this.per_page = 10
      this.$http
        .get(
          `${this.$api.endpoint}/poi/datatable?page=${this.page}&per_page=${this.per_page}&search=${this.keyword}`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.row_total = res.data.message.total
          this.data = res.data.message.data
          this.loading = false
          // this.polygons = []
          // this.markers = []

          this.data.map((item) => {
            let key = -1
            let target = item.type === 0 ? 'markers' : 'polygons'
            let latlngs =
              item.type === 0
                ? L.latLng(item.lat, item.lon)
                : this.geomToPolygon(item.geom)

            this[target].map((i, index) => {
              if (i.id === item.id) key = index
            })

            if (key === -1) {
              this[target].push({
                id: item.id,
                name: item.name,
                latlngs: latlngs,
                center: L.latLng(item.lat, item.lon),
                visible: false,
                icon: item.icon
                  ? L.icon({
                      iconUrl: `${
                        item.icon.fullpath_icon
                          ? item.icon.fullpath_icon
                          : item.icon.icon
                      }`, // `${this.$api.base_url}/uploads/icon/${item.icon.icon}`,
                      iconSize: [20, 20]
                    })
                  : L.icon.Default
              })
            }
          })
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    geomToPolygon(geom) {
      let start = '(('
      let end = '))'

      geom = geom.substring(
        geom.indexOf(start) + start.length,
        geom.indexOf(end)
      )

      let latlon = geom.split(',')

      let result = []
      latlon.map((item) => {
        let x = item.split(' ')
        result.push([parseFloat(x[1]), parseFloat(x[0])])
      })

      return result
    },

    polygonToGeom(polygon) {
      let lonlat = ''
      polygon.map((item, index) => {
        // if(index > 0) lonlat += ', '
        if (index === 0)
          lonlat += `${item.lng} ${item.lat}, ${item.lng} ${item.lat}`
        else lonlat += `, ${item.lng} ${item.lat}`
      })

      lonlat += `, ${polygon[0].lng} ${polygon[0].lat}`

      return `POLYGON ((${lonlat}))`
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/vuexy/extraComponents/tree.scss';
</style>
